<template>
<v-card>
     <v-card-title>
       <v-icon x-large>mdi-account-details</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="roleusers"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field :disabled="true" v-model="editedItem.ApiRole_id"
                        label="Rol ID"  :counter="30" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field :disabled="true" v-model="editedItem.ApiUser_id"
                        label="Usuario ID"  :counter="30" required></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-select
                        v-model="editedItem.ApiRoleEnable_Ind"
                        :items="['S', 'N']"
                        :rules="[v => !!v || 'El campo es obligatorio']"
                        label="Habilitado Ind"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO ROL - USUARIO</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiRole_id"
                        :items="roles"
                        :rules="idRules"
                        label="Rol ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                      <v-select
                        v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="userIdRules"
                        label="Usuario ID"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="6" sm="6" md="4">
                      <v-select
                        v-model="editedItem.ApiRoleEnable_Ind"
                        :items="['S', 'N']"
                        :rules="[v => !!v || 'El campo es obligatorio.']"
                        label="Habilitado Ind"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    headers: [
      { text: 'Role ID', value: 'ApiRole_id' },
      { text: 'Usuario ID', value: 'ApiUser_id' },
      { text: 'Habilitado Ind', value: 'ApiRoleEnable_Ind' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    roleusers: [],
    users: [],
    roles: [],
    editedIndex: -1,
    editedItem: {
      ApiRole_id: '',
      ApiUser_id: '',
      ApiRoleEnable_Ind: 'S'
    },
    defaultItem: {
      ApiRole_id: '',
      ApiUser_id: '',
      ApiRoleEnable_Ind: 'S'
    },
    idRules: [
      v => !!v || 'Rol ID es requerido',
      v => (v && v.length <= 30) || 'Rol ID debe tener menos de 30 caracteres'
    ],
    userIdRules: [
      v => !!v || 'Usaurio ID es requerido',
      v => (v && v.length <= 30) || 'Usaurio ID debe tener menos de 30 caracteres'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Rol - User' : 'Editar Rol - User'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      console.log(this.config)
      axios.post(this.api_tool_url + '/get_roleuser', {}, this.config)
        .then(response => {
          this.roleusers = response.data.ResultRows
        })
        .catch(error => {
          this.roleusers = []
          alert(error.response.data.message)
        })

      axios.post(this.api_tool_url + '/get_users', {}, this.config)
        .then(response => {
          response.data.ResultRows.forEach(data => {
            this.users.push(data.ApiUser_id)
          })
        })
        .catch(error => {
          this.users = []
          alert(error.response.data.message)
        })

      axios.post(this.api_tool_url + '/get_roles', {}, this.config)
        .then(response => {
          response.data.ResultRows.forEach(data => {
            this.roles.push(data.ApiRole_id)
          })
        })
        .catch(error => {
          this.roles = []
          alert(error.response.data.message)
        })
    },

    newtItem (item) {
      this.editedIndex = this.roleusers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.roleusers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.roleusers.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.deleteRoleUser(index)
    },

    deleteRoleUser (index) {
      let roleusersTmp = this.roleusers[index]
      delete roleusersTmp.ApiRoleEnable_Ind
      axios.post(this.api_tool_url + '/del_roleuser', roleusersTmp, this.config)
        .then(response => {
          this.roleusers.splice(index, 1)
          this.close()
        })
        .catch(error => {
          this.roleusers = []
          alert(error.response.data.message)
        })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_roleuser', this.editedItem, this.config)
          .then(response => {
            Object.assign(this.roleusers[this.editedIndex], response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.roleusers = []
            alert(error.response.data.message)
          })
      } else {
        axios.post(this.api_tool_url + '/ins_roleuser', this.editedItem, this.config)
          .then(response => {
            this.roleusers.push(response.data.ResultRows[0])
            this.close()
          })
          .catch(error => {
            this.roleusers = []
            alert(error.response.data.message)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RoleUserGrid.vue